// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickJournalDuneDustParticles__container___VkBFK {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 3;
}

.QuickJournalDuneDustParticles__container___VkBFK span {
    position: absolute;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background: rgba(255, 214, 146, 0.42);
    box-shadow:
        0 0 4px rgba(255, 190, 112, 0.24),
        0 0 12px rgba(232, 137, 61, 0.12);
    opacity: 0;
    animation: QuickJournalDuneDustParticles__quickJournalDuneUpperDustDrift___U8exJ 18s linear infinite;
}

.QuickJournalDuneDustParticles__particleOne___sJlEg {
    left: 36%;
    top: 62%;
    animation-duration: 16s;
    animation-delay: -7s;
}

.QuickJournalDuneDustParticles__particleTwo___hEeL4 {
    left: 68%;
    top: 54%;
    width: 1px;
    height: 1px;
    opacity: 0.64;
    animation-duration: 20s;
    animation-delay: -12s;
}

.QuickJournalDuneDustParticles__particleThree___mq7uE {
    left: 84%;
    top: 72%;
    width: 1px;
    height: 1px;
    opacity: 0.52;
    animation-duration: 24s;
    animation-delay: -18s;
}

.QuickJournalDuneDustParticles__particleFour___qtxwA {
    left: 7%;
    top: 18%;
    width: 1px;
    height: 1px;
    animation-duration: 13s;
    animation-delay: -9s;
}

.QuickJournalDuneDustParticles__particleFive___dM2FG {
    left: 14%;
    top: 48%;
    animation-duration: 17s;
    animation-delay: -3s;
}

.QuickJournalDuneDustParticles__particleSix___FPePK {
    left: 22%;
    top: 31%;
    width: 1px;
    height: 1px;
    animation-duration: 21s;
    animation-delay: -14s;
}

.QuickJournalDuneDustParticles__particleSeven___EHy6Z {
    left: 31%;
    top: 76%;
    animation-duration: 15s;
    animation-delay: -11s;
}

.QuickJournalDuneDustParticles__particleEight___eEraF {
    left: 43%;
    top: 23%;
    width: 3px;
    height: 3px;
    animation-duration: 19s;
    animation-delay: -16s;
}

.QuickJournalDuneDustParticles__particleNine___DDSRI {
    left: 51%;
    top: 68%;
    width: 1px;
    height: 1px;
    animation-duration: 12s;
    animation-delay: -5s;
}

.QuickJournalDuneDustParticles__particleTen___iZ5d2 {
    left: 59%;
    top: 39%;
    animation-duration: 18s;
    animation-delay: -10s;
}

.QuickJournalDuneDustParticles__particleEleven___JVkza {
    left: 73%;
    top: 14%;
    width: 1px;
    height: 1px;
    animation-duration: 14s;
    animation-delay: -8s;
}

.QuickJournalDuneDustParticles__particleTwelve___Sy_sO {
    left: 78%;
    top: 58%;
    animation-duration: 22s;
    animation-delay: -19s;
}

.QuickJournalDuneDustParticles__particleThirteen___vg2YK {
    left: 89%;
    top: 38%;
    width: 1px;
    height: 1px;
    animation-duration: 16s;
    animation-delay: -4s;
}

.QuickJournalDuneDustParticles__particleFourteen___kTLv4 {
    left: 94%;
    top: 76%;
    animation-duration: 20s;
    animation-delay: -13s;
}

.QuickJournalDuneDustParticles__particleFifteen___dZHfW {
    left: 3%;
    top: 66%;
    width: 1px;
    height: 1px;
    animation-duration: 12s;
    animation-delay: -7s;
}

@keyframes QuickJournalDuneDustParticles__quickJournalDuneUpperDustDrift___U8exJ {
    0%,
    100% {
        opacity: 0;
        transform: translate3d(-18px, 10px, 0) scale(0.72);
    }

    18% {
        opacity: 0.62;
    }

    48% {
        opacity: 0.3;
        transform: translate3d(30px, -14px, 0) scale(1);
    }

    74% {
        opacity: 0.52;
        transform: translate3d(62px, 10px, 0) scale(0.86);
    }
}

@media (prefers-reduced-motion: reduce) {
    .QuickJournalDuneDustParticles__container___VkBFK span {
        animation: none;
        opacity: 0.22;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuickJournalDuneDustParticles__container___VkBFK`,
	"quickJournalDuneUpperDustDrift": `QuickJournalDuneDustParticles__quickJournalDuneUpperDustDrift___U8exJ`,
	"particleOne": `QuickJournalDuneDustParticles__particleOne___sJlEg`,
	"particleTwo": `QuickJournalDuneDustParticles__particleTwo___hEeL4`,
	"particleThree": `QuickJournalDuneDustParticles__particleThree___mq7uE`,
	"particleFour": `QuickJournalDuneDustParticles__particleFour___qtxwA`,
	"particleFive": `QuickJournalDuneDustParticles__particleFive___dM2FG`,
	"particleSix": `QuickJournalDuneDustParticles__particleSix___FPePK`,
	"particleSeven": `QuickJournalDuneDustParticles__particleSeven___EHy6Z`,
	"particleEight": `QuickJournalDuneDustParticles__particleEight___eEraF`,
	"particleNine": `QuickJournalDuneDustParticles__particleNine___DDSRI`,
	"particleTen": `QuickJournalDuneDustParticles__particleTen___iZ5d2`,
	"particleEleven": `QuickJournalDuneDustParticles__particleEleven___JVkza`,
	"particleTwelve": `QuickJournalDuneDustParticles__particleTwelve___Sy_sO`,
	"particleThirteen": `QuickJournalDuneDustParticles__particleThirteen___vg2YK`,
	"particleFourteen": `QuickJournalDuneDustParticles__particleFourteen___kTLv4`,
	"particleFifteen": `QuickJournalDuneDustParticles__particleFifteen___dZHfW`
};
module.exports = ___CSS_LOADER_EXPORT___;
